var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolidStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7514 2.96659L15.1904 7.88059C15.3114 8.12859 15.5464 8.30059 15.8194 8.34159L21.2774 9.13259C21.4984 9.16159 21.6984 9.27859 21.8334 9.45659C22.0874 9.78759 22.0494 10.2596 21.7444 10.5456L17.7904 14.3856C17.5904 14.5726 17.5004 14.8506 17.5524 15.1186L18.5054 20.5316C18.5714 20.9816 18.2664 21.3996 17.8194 21.4736C17.6334 21.5026 17.4434 21.4726 17.2764 21.3886L12.4084 18.8376C12.1644 18.7046 11.8704 18.7046 11.6274 18.8376L6.72738 21.4066C6.31838 21.6126 5.82238 21.4576 5.60038 21.0596C5.51538 20.8986 5.48438 20.7126 5.51438 20.5316L6.46738 15.1186C6.51338 14.8506 6.42438 14.5756 6.22938 14.3856L2.24438 10.5446C1.91938 10.2206 1.91838 9.69459 2.24238 9.36859C2.24338 9.36859 2.24338 9.36759 2.24438 9.36659C2.37738 9.24559 2.54238 9.16359 2.72038 9.13259L8.17838 8.34159C8.44938 8.29759 8.68438 8.12559 8.80738 7.88059L11.2464 2.96659C11.3434 2.76659 11.5174 2.61359 11.7284 2.54359C11.9394 2.47259 12.1704 2.48859 12.3704 2.58959C12.5344 2.67159 12.6674 2.80359 12.7514 2.96659Z",
    stroke: "#200E32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    fill: "#200E32",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidStar);
export default __webpack_public_path__ + "static/media/solidStar.200bb5ed57b79f2ddb9ff65100cffaec.svg";
export { ForwardRef as ReactComponent };